import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Index from "./pages/Index.tsx";
import VideoPortfolio from "./pages/VideoPortfolio.tsx";
import ProductPhotos from "./pages/ProductPhotos.tsx";
import AiServices from "./pages/AiServices.tsx";
import ThankYou from "./pages/ThankYou.tsx";
import BlogIndex from "./pages/BlogIndex.tsx";
import BlogPost from "./pages/BlogPost.tsx";
import Sitemap from "./pages/Sitemap.tsx";
import AmazonProductVideo from "./pages/AmazonProductVideo.tsx";
import AmazonBrandStore from "./pages/AmazonBrandStore.tsx";
import EcommerceContentROI from "./pages/EcommerceContentROI.tsx";
import CustomJingles from "./pages/CustomJingles.tsx";
import ShopifyWebDev from "./pages/ShopifyWebDev.tsx";
import Content from "./pages/Content.tsx";
import NotFound from "./pages/NotFound.tsx";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/video-portfolio" element={<VideoPortfolio />} />
          <Route path="/product-photos" element={<ProductPhotos />} />
          <Route path="/ai" element={<AiServices />} />
          <Route path="/thank-you-confirmation" element={<ThankYou />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/amazon-product-video-production" element={<AmazonProductVideo />} />
          <Route path="/amazon-brand-store-design" element={<AmazonBrandStore />} />
          <Route path="/ecommerce-content-roi" element={<EcommerceContentROI />} />
          <Route path="/custom-jingles-sonic-branding" element={<CustomJingles />} />
          <Route path="/shopify-web-development" element={<ShopifyWebDev />} />
          <Route path="/content" element={<Content />} />
          <Route path="/sitemap" element={<Sitemap />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
